/* istanbul ignore file */
export { default } from './PromoBanner';
